import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, Stack, Text, useToast } from "@chakra-ui/react";
import { Dialog, Form } from "components";
import { API } from "config";
import { Mask } from "config";
import { useState } from "react";

export default function Select({ data, order, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/orders/${order.data?.id}/quotation/update`, { company: data?.company?.name, price: data?.price * 100 })
            toast({ title: 'Cotação realizada com sucesso', status: 'success' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível salvar a cotação.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }
    

    return(
    <Dialog title="Selecionar cotação" {...props}>
        <AlertDialogBody fontSize="sm">
            <Stack>
                <Text>Você tem certeza de que deseja selecionar esta cotação de frete para o pedido?</Text>
                <Divider />

                <Form.Text isDisabled label="Transportadora" value={data?.company?.name} />
                <Form.Text isDisabled label="Valor" value={`R$ ${Mask.price(data?.price * 100)}`} />
            </Stack>
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Salvar cotação" isLoading={loading} onClick={handleSubmit} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>
    )
}